import * as React from 'react';
import ModalContext from './ModalContext';
export const ModalTrigger = ({ target, children, modalStyles }) => {
    return (React.createElement(ModalContext.Consumer, null, ({ showTarget, hideTarget }) => {
        const show = () => showTarget(target, 'modal', null, { hideTarget, modalStyles });
        return children({ showTarget: show });
    }));
};
//# sourceMappingURL=ModalTrigger.js.map